import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const processClaimsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    processClaims: builder.mutation({
      query: body => ({
        url: 'process_claims/',
        method: 'POST',
        body,
      }),
      invalidatesTags: [],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useProcessClaimsMutation
} = processClaimsApi;
